import { useTranslation } from "react-i18next";
import { formatCampaignDateRangeBadge } from "../campaignFormatUtils";

const CampaignDateBadge = ({ start, stop }) => {
  const { i18n } = useTranslation();

  if (!start || !stop) {
    return null;
  }

  const label = formatCampaignDateRangeBadge(start, stop, i18n.language);

  return (
    <span className="char-badge campaign-date-badge">
      <i
        className="far fa-calendar-alt campaign-date-badge__icon"
        aria-hidden
      />
      {label}
    </span>
  );
};

export default CampaignDateBadge;
